import { useBranding } from 'hooks'
import { FC } from 'react'
import scss from './index.module.scss'

type TopBarLogoProps = {
  logoUrl?: string
  className?: string
}

export const TopBarLogo: FC<TopBarLogoProps> = () => {
  const {
    logo: { topBarLogo },
  } = useBranding()

  if (!topBarLogo) return null

  return (
    <img src={topBarLogo} alt='Organization Logo' className={scss.topBarLogo} />
  )
}
